module.exports = __webpack_public_path__ + "static/media/food.98324bad.JPG";